module.exports = __webpack_public_path__ + "img/Dantam Hair 42.f69bb274.jpg";